
import { Injectable } from '@angular/core';
import { Request, RequestOptions, Headers, Response } from '@angular/http';
import { HttpClient } from '../../services/http.service';
import { AppConstants } from '../../app.constants';
import { Observable } from 'rxjs/Rx';
import { LocalStorageService } from 'ng2-webstorage';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database-deprecated';
@Injectable()
export class AdminLayoutService {
    private schoolId: string;
    public messageId: string;
    public schoolUser: string;
    public userId: string;
    public Token: string;
    constructor(private httpClient: HttpClient, private appConstants: AppConstants, private localStorage: LocalStorageService, private firebasedb: AngularFireDatabase) {

        this.messageId = '';
    }

    public GetSoundingBoardPrivateMessage(pagenum, searchString, standard, section): Observable<Response> {
        this.schoolId = this.localStorage.retrieve('SchoolId');
        this.schoolUser = this.localStorage.retrieve('Id');
        if (!searchString) {
            if (standard.length > 0 && section.length > 0) {
                var url: string = '' + this.appConstants.baseUrl + this.appConstants.GetSoundingBoardPrivateMessage + '?schoolUser=' + this.schoolUser + '&schoolId=' + this.schoolId + '&PageSize=' + 10 + '&pageNumber=' + pagenum + '&Type=0';

            }
            else {
                var url: string = '' + this.appConstants.baseUrl + this.appConstants.GetSoundingBoardPrivateMessage + '?schoolUser=' + this.schoolUser + '&schoolId=' + this.schoolId + '&PageSize=' + 10 + '&pageNumber=' + pagenum + '&Type=0';
            }

        }
        else {
            if (standard.length > 0 && section.length > 0) {
                var url: string = '' + this.appConstants.baseUrl + this.appConstants.GetSoundingBoardPrivateMessage + '?schoolId=' + this.schoolId + '&searchString=' + searchString + '&PageSize=' + 10 + '&pageNumber=' + pagenum + '&Type=0';
            }
            else {
                var url: string = '' + this.appConstants.baseUrl + this.appConstants.GetSoundingBoardPrivateMessage + '?schoolId=' + this.schoolId + '&searchString=' + searchString + '&PageSize=' + 10 + '&pageNumber=' + pagenum + '&Type=0';
            }

        }

        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }


    public didReadMsg(msgId, payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.didreadSbMsg + '?messageid=' + msgId;
        return this.httpClient.Post(url, payload)
            .map(this.extractData)
            .catch(this.handleError)
    }

    public getGclStatus(): Observable<Response> {
        this.schoolId = this.localStorage.retrieve('SchoolId');
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.getGCLMenuStatus+ '?schoolid=' + this.schoolId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    public getDAStatus(): Observable<Response> {
        this.schoolId = this.localStorage.retrieve('SchoolId');
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.getDAStatus+ '?schoolid=' + this.schoolId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    private extractData(res: Response) {
        let body = res.json();
        return body;
    }

    private handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        let err = JSON.parse(error._body);
        return Observable.throw(err);
    }

    public permission(userId):Observable<Response>{
        this.userId = this.localStorage.retrieve("Id");
        let headers = new  Headers({'Content-Type':'application/json'});
        let options = new RequestOptions({
            headers:headers
        });
        let url:string = ''+this.appConstants.baseUrl+ this.appConstants.GetUserPermissions+'?userId='+ userId;
        return this.httpClient.Get(url,userId)
        .map(this.extractData)
        .catch(this.handleError)
    }
    public Logout():Observable<any>{
        this.Token = this.localStorage.retrieve("Token");
        let headers = new  Headers({'Content-Type':'application/json'});
        let options = new RequestOptions({
            headers:headers
        });
        let url:string = ''+this.appConstants.baseUrl+ this.appConstants.logout+'?token='+ this.Token;
        return this.httpClient.Delete(url)
        .map(this.extractData)
        .catch(this.handleError)
    }
}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/layouts/admin/admin-layout.service.ts